/**
 * Get fallback flow name if name is not provided
 */
export function getFlowName(flow: { flow_id?: number; name?: string }): string {
    return flow.name || `Flow ${flow.flow_id || ''}`;
}

/**
 * Format recipient count for display
 */
export function formatRecipientCount(count: number): string {
    if (count === 0) return 'No Recipients';
    if (count === 1) return '1 Recipient';
    return `${count} Recipients`;
}

/**
 * Format email count for display
 */
export function formatEmailCount(count: number): string {
    if (count === 0) return 'No Emails';
    if (count === 1) return '1 Email';
    return `${count} Emails`;
}
